import { State as ListState, reducer as listReducer } from "features/menu/reducers/list";
import { State as EditState, reducer as editReducer } from "features/menu/reducers/edit";
import { combineReducers } from "redux";

export interface State {
    menus: {
        list: ListState;
        edit: EditState;
    };
}

export const reducer = combineReducers({
    list: listReducer,
    edit: editReducer,
});
